

import { List, ListItem } from '@mui/material';
import { useFieldState, useFormState } from '@ngt/forms-core';
import { FC, useEffect, useState } from 'react';

const FieldErrors: FC = () => {
    const { errors, touched } = useFieldState({ errors: true, touched: true });
    const { validating } = useFormState({ validating: true})

    const [touchGrass, setTouchGrass] = useState(touched);

    useEffect(() => {
        if (!validating && touched) {
            setTouchGrass(true);
        }
    }, [validating, touched])

    if (!errors || errors.length === 0 || !touchGrass) {
        return null;
    }

    return (
        <List>
            {
                errors.map((error, i) => (
                    <ListItem key={i} sx={{ color: 'red' }}>{error}</ListItem>
                ))
            }
        </List>
    );
}


export default FieldErrors;